export {};
//# sourceMappingURL=Timestamp.types.js.map